// src/utils/browser.js
import { Capacitor } from '@capacitor/core';

/**
 * Opens a URL in the in-app browser on native platforms,
 * or in a new tab on web.
 * @param {string} url - The URL to open
 */
export const openInAppBrowser = async (url) => {
  if (!url) return;
  
  // Check if we're on a native platform
  const isNative = Capacitor.isNativePlatform();
  
  if (isNative) {
    try {
      // Dynamically import the Browser plugin to ensure it's available
      const { Browser } = await import('@capacitor/browser');
      
      // Open in-app browser on native platforms (SFSafariViewController on iOS)
      await Browser.open({ url });
    } catch (error) {
      // If Browser plugin fails, fall back to opening in default browser
      // This uses Capacitor's built-in URL handling
      window.location.href = url;
    }
  } else {
    // Open in new tab on web
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

/**
 * Creates an onClick handler for links that should open in the in-app browser
 * @param {string} url - The URL to open
 * @returns {function} Click handler function
 */
export const createBrowserLinkHandler = (url) => {
  return (e) => {
    e.preventDefault();
    e.stopPropagation();
    openInAppBrowser(url);
  };
};
